import "./portfolio.scss"

export default function Portfolio() {
    return (
        <div className="portfolio" id="portfolio">
            <h1>Portfolio</h1>
            <ul>
                <li className="active">Featured</li>
                <li>Ecommerce Site</li>
                <li>Video Chat App</li>
                <li>To-do list</li>
                <li>Space Evade</li>

            </ul>
            <div className="container">
                <div className="item">
                    <img
                        src =""
                        alt=""
                        />
                </div>
                <div className="item">
                    <img
                        src =""
                        alt=""
                        />
                </div>
                <div className="item">
                    <img
                        src =""
                        alt=""
                        />
                </div>
                <div className="item">
                    <img
                        src =""
                        alt=""
                        />
                </div>
            </div>
            
        </div>
    )
}
